import { List } from 'antd';
import styled from 'styled-components';

const ListStyled = styled(List)``;

export default ListStyled;
